export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7433.e6a0f98e.jpg";